import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import BlogRightSidebar from './blog-components/blog-right-sidebar';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import TopBar from './global-components/topbar';
import ComingSoon from './section-components/coming-soon';

const BlogRightSidebarPage = () => {
    return <div>
        <TopBar/>
        <Navbar />
        <PageHeader headertitle="Blog" subheader="Blog" />
        {/* <BlogRightSidebar /> */}
        <ComingSoon />
        {/* <CallToActionV1 /> */}
        <Footer />
    </div>
}

export default BlogRightSidebarPage

